import {
  FaClock,
  FaPhoneAlt,
  FaEnvelope,
  FaGlobe,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "./PendingApproval.css";
import { useNavigate } from "react-router-dom";

export default function PendingApproval() {
  const navigate = useNavigate();
  return (
    <div className="pending-page">
      <div className="pending-card">
        <div className="pending-icon">
          <FaClock />
        </div>

        <span className="pending-badge">Waiting For Approval</span>

        <h1>Account Pending Approval</h1>

        <p className="pending-text">
          Thank you for registering with <strong>NN FIT Software</strong>.
          <br />
          Your gym account has been submitted successfully and is currently
          awaiting administrator approval.
        </p>

        <div className="contact-box">
          <h3>Need Assistance?</h3>

          <div className="contact-item">
            <FaPhoneAlt />
            <span>+91 8688663447</span>
          </div>

          <div className="contact-item">
            <FaEnvelope />
            <span>info@nnfit.com</span>
          </div>

          <div className="contact-item">
            <FaGlobe />
            <span>www.nnaisolution.com</span>
          </div>

          <div className="contact-item">
            <FaMapMarkerAlt />
            <span>IT Towers, Nizamabad, Telangana</span>
          </div>
        </div>

        {/* <button className="home-btn" onClick={() => window.location.reload()}>
          Refresh Status
        </button> */}
        <button className="home-btn" onClick={() => navigate("/login")}>
          Go to Login
        </button>
      </div>
    </div>
  );
}
